/* eslint-disable camelcase,no-console */
import { TelemetryLocation } from "@teaming/common-enums";
import streamTelemetry from "./stream";

export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		...streamTelemetry( { currentUser, amplitude, intercom, } ),
		openTeamCreationDialog() {
			amplitude.event( "Team Creation Dialog Opened", {
				creation_location: TelemetryLocation.TEAM_SPACES,
			} );
		},
		viewTeamListPage() {
			amplitude.event( "View Team List Page", {} );
		},
		viewTeamStreamTab( {
			teamId,
			teamName,
			teamCompositeWorkStyleType,
			thisMemberWorkStyleType,
			thisMemberRole,
		} ) {
			amplitude.event( "View Team Spaces Meetings Tab", { team_name: teamName, } );

			intercom.trackEvent( "Team Notes and Meetings Tab Viewed", {
				team_id: teamId,
				team_display_name: teamName,
				team_composite_ws_type: teamCompositeWorkStyleType,
				this_member_ws_type: thisMemberWorkStyleType,
				this_member_role: thisMemberRole,
			} );
		},
		viewTeamOverviewTab( { teamName, } ) {
			amplitude.event( "View Team Spaces Overview Tab", { team_name: teamName, } );
		},
		viewTeamSettingsTab( { teamName, } ) {
			amplitude.event( "View Team Spaces Settings Tab", { team_name: teamName, } );
		},
		viewTeamWorkStyleTab( { teamName, } ) {
			amplitude.event( "View Team Work Style", { team_name: teamName, } );
		},
		viewTeamGoalsTab( { teamName, } ) {
			amplitude.event( "View Team Spaces Goals Tab", { team_name: teamName, } );
		},
		viewTeamCommitmentsTab( { teamName, } ) {
			amplitude.event( "View Team Spaces Commitments Tab", { team_name: teamName, } );
		},
		viewTeamHealthTab( { teamName, } ) {
			amplitude.event( "View Team Health Tab", { team_name: teamName, } );
		},
		teamCreated( { teamName, } ) {
			/*
				NOTE: in reports we had the TeamCreatedEvent enum, since teams could
				be created from the team listing or the schedule view. The schedule
				view is deprecated, so I'm not bringing the enum over, but I am hard-
				coding the creation_location value below as to not break Stephen's reports
			*/
			amplitude.event( "Team Created", {
				team_name: teamName,
				creation_location: "TEAM_LIST_LOCATION",
			} );
		},
		teamNameUpdated() {
			amplitude.event( "Team Name Updated" );
		},
		teamMemberRoleChange( { teamName, userEmail, newRole, } ) {
			amplitude.event( "Team Member Role Change", {
				team_name: teamName,
				user_email: userEmail,
				new_role: newRole,
			} );
		},
		teamMemberRemoved( { teamName, removedEmail, } ) {
			amplitude.event( "Team Member Removed", {
				team_name: teamName,
				removed_email: removedEmail,
			} );
		},
		teamMemberInvited( { teamName, invitedUserEmail, location, } ) {
			amplitude.event( "Team Member Invited", {
				team_name: teamName,
				invited_user_email: invitedUserEmail,
				location: location || "Team Space",
			} );
		},
		teamHealthSurveyInitiated( { surveyId, surveyDate, teamName, } ) {
			amplitude.event( "Health Assessment Initiated", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
			} );
		},
		teamHealthSurveyStarted( { surveyId, surveyDate, teamName, } ) {
			amplitude.event( "Health Survey Started", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
			} );
		},
		teamHealthSurveyCompleted( { surveyId, surveyDate, teamName, } ) {
			amplitude.event( "Health Survey Completed", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
			} );
		},
		teamHealthSurveyPublished( { surveyId, surveyDate, teamName, } ) {
			amplitude.event( "Health Assessment Results Published", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
			} );
		},
		teamHealthResultsViewed( { surveyId, surveyDate, teamName, } ) {
			amplitude.event( "Health Assessment Results Viewed", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
			} );
		},
		teamHealthShowMyScores( { surveyId, surveyDate, teamName, isShowing, } ) {
			amplitude.event( "Health Assessment - Show My Scores", {
				instance_id: surveyId,
				instance_name: surveyDate,
				team_name: teamName,
				state: isShowing ? "show" : "hide",
			} );
		},
		coachingContentViewed( { fromLocation = "Team Health", coachingURL, } ) {
			amplitude.event( "Coaching Content Viewed", {
				from_location: fromLocation,
				view_url: coachingURL,
			} );
		},
		addMeetingTemplate( { templateTitle, } ) {
			amplitude.event( "Meeting Template Added", {
				template: templateTitle,
				location: TelemetryLocation.TEAM_SPACES,
			} );
		},
		addCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Added to Meeting", {
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
				template,
			} );
		},
		createdCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Created", {
				location: TelemetryLocation.TEAM_SPACES,
				template,
			} );
		},
		deletedCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Deleted", {
				location: TelemetryLocation.TEAM_SPACES,
				template,
			} );
		},
		addSuggestedTopic( { categoryName, topicText, } ) {
			amplitude.event( "Suggested Topic Added", {
				category: categoryName,
				topic: topicText,
				// NOTE: update when we allow this from additional locations
				location: TelemetryLocation.TEAM_SPACES,
			} );
		},
		openSuggestedTopicPanel() {
			amplitude.event( "Suggested Topic Panel Opened", {
				// NOTE: update when we allow this from additional locations
				location: TelemetryLocation.TEAM_SPACES,
			} );
		},
	};
};
